import {CodeName} from "./code-name";
import {GUID} from "../../shared/models/GUID-interface";

export class ClearSelected {
    constructor(
        public readonly name: string, public readonly clearAll: boolean
    ) {
        this.data = null;
    }
    public data: CodeName
}

export class ClearSelectedGUID implements GUID{
    constructor(
        public readonly GUID: string, public readonly clearSelected: ClearSelected
    ) {

    }
}



// WEBPACK FOOTER //
// ./src/app/stocks/models/clear-selected.ts